import { Component, DestroyRef, OnInit, Renderer2, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { environment } from 'src/environments/environment';
import { Logger } from './core/service/logger.service';
import { ThemeService } from './core/service/theme.service';
import { AuthService } from './seguranca/auth.service';
import { LiberacaoSseService } from './view/gerencial/solicitacao-liberacao-page/services/liberacao-sse.service';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: ` <router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  private readonly titleService = inject(Title);
  private readonly translateService = inject(TranslateService);
  private readonly themeService = inject(ThemeService);
  private readonly renderer = inject(Renderer2);
  private readonly primeng = inject(PrimeNG);
  private readonly auth = inject(AuthService);
  private readonly liberacaoSse = inject(LiberacaoSseService);
  private readonly destroyRef = inject(DestroyRef);

  title = environment.configuracaoThema.name;

  ngOnInit() {
    this.atualizarTitulo();
    this.themeService.applyTheme(this.renderer);

    this.auth.isAuthenticated
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((authenticated) => {
        if (authenticated && this.auth.isAdmin()) {
          this.liberacaoSse.iniciar();
        } else if (!authenticated) {
          this.liberacaoSse.encerrar();
        }
      });

    this.translateService.setDefaultLang('pt');
    this.translate('pt');

    if (environment.production) {
      Logger.enableProductionMode();
    }

    log.debug('init');
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService
      .get('primeng')
      .subscribe((res) => this.primeng.setTranslation(res));
  }

  private atualizarTitulo() {
    this.titleService.setTitle(this.title);
  }
}
